export default class DynamicScriptLoad {
    constructor() {
      // initialize
      try {
        this.filesToLoad = JSON.parse(document.currentScript.dataset.srcdirload);
      } catch (error) {
        console.error(error);
        console.error(document.currentScript)
      }
      let sourceAttribute = document.currentScript.src
      this.sourceDirectory = sourceAttribute.slice(0, (sourceAttribute.lastIndexOf('/') + 1));
      console.log(this.sourceDirectory);
      this.copeSourceDirectory  = 'https://www.montana.edu/cope/phantom/js/';
    };
  
    // public methods
    load(prefix = '') {
      for (let script of this.filesToLoad) {
        let element = document.createElement("script");
        if (script == 'colorcontrast.js' || script == 'copewebscan.js') {
          element.src = this.copeSourceDirectory + prefix + script;
        } else {
          element.src = this.sourceDirectory + prefix + script;
        }
        console.log(element.src);
        element.type = "text/javascript";
        element.async = false;
        element.defer = false;
        document.getElementsByTagName("head")[0].appendChild(element);
      }
  
    }
  }